/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import PropTypes from 'prop-types';

class Change extends React.Component {
  getClassname(change) {
    if (isNaN(change) || change === 0) {
      return 'text-muted';
    }

    if (change > 0) {
      return 'text-danger';
    }

    return 'text-success';
  }

  getText(change) {
    if (isNaN(change)) {
      return '---';
    }

    if (change === 0) {
      return '0%';
    }

    let displayableChange = change * 100;

    if (!isFinite(displayableChange)) {
      displayableChange = '∞';
    }

    return (
      <span>
        {displayableChange}% <span className={`${change < 0 ? 'icon-arrow-down' : 'icon-arrow-up'} ${this.getClassname(change)} font-weight-bold`} />
      </span>
    );
  }

  render() {
    return (
      <span className="text-muted">
        {this.getText(this.props.change)}
      </span>
    );
  }
}

Change.propTypes = {
  change: PropTypes.number.isRequired,
};

export default Change;



// WEBPACK FOOTER //
// ./src/components/core/Change.js